import { Navigate, useLocation } from "react-router";
import { useAuth } from "./AuthProvider";

export const PrivateRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();
    const { pathname, search } = useLocation();

    if (isLoading) {
        return <div>Loading authentication status...</div>;
    }
    return isAuthenticated ? (
        children
    ) : (
        <Navigate
            to="/account/signin"
            state={{ returnUrl: pathname + search }}
        />
    );
};

export const PublicRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return <div>Loading authentication status...</div>;
    }
    return isAuthenticated ? <Navigate to="/" /> : children;
};
